import AuthTestKitActivation from './AuthTestKitActivation';
import { useThemeContext } from '../../contexts/ThemeContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AUTHENTICATED, UNAUTHENTICATED } from '../../constants/user';
import GuestTestKitActivation from './guest/GuestTestKitActivation';
import { isTestKitActivationDisabled } from './DisableActivation';

export interface TestKitActivationFormProps {
  disableTestKitActivation: boolean;
}

const MainTestKitActivation = () => {
  const { userType } = useThemeContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const disableTestKitActivation = isTestKitActivationDisabled();

  useEffect(() => {
    if (userType === UNAUTHENTICATED) {
      if (!(location && location.pathname.includes('guest-activate'))) {
        return navigate('/guest-activate.html');
      }
    }
    setIsAuthenticated(userType === AUTHENTICATED);
  }, [userType, navigate, location]);

  if (isAuthenticated) {
    return <AuthTestKitActivation disableTestKitActivation={disableTestKitActivation} />;
  } else {
    return <GuestTestKitActivation disableTestKitActivation={disableTestKitActivation} />;
  }
};

export default MainTestKitActivation;
